/**
 * How a Sage budget is named in the UI. Finance knows budgets by their Sage budget ID ("Q3 2026");
 * the Sage description is often a date stamp ("08172026"), so it is only shown as secondary text,
 * and only when it adds something: not empty, not the ID again, not date-like.
 */
const DATE_LIKE =
  /^(\d{6}|\d{8}|\d{1,2}[/.-]\d{1,2}[/.-]\d{2,4}|\d{4}[/.-]\d{1,2}[/.-]\d{1,2}|[A-Za-z]{3,9}\.? \d{1,2},? \d{4})$/

export interface BudgetRef {
  id: string
  description?: string | null
}

/** The description worth showing next to the ID, or null. */
export function budgetSecondary(budget: BudgetRef): string | null {
  const text = budget.description?.trim()
  if (!text) return null
  if (text.toLowerCase() === budget.id.trim().toLowerCase()) return null
  if (DATE_LIKE.test(text)) return null
  return text
}

/** One-line label for plain text (select options): `Q3 2026 · Revised plan`, or just the ID. */
export function budgetText(budget: BudgetRef): string {
  const secondary = budgetSecondary(budget)
  return secondary ? `${budget.id} · ${secondary}` : budget.id
}
